import React, { useEffect, useState } from 'react';
import RecipientForm from "../recipient/RecipientForm"
import ReviewYourTransfer from '../../modals/ReviewYourTransfer';
import { BsChevronDoubleRight, BsFillPersonPlusFill } from 'react-icons/bs';
import { createTransaction, recipientList, updateRecipientCurrency } from '../../../utils/Api';
import { useNavigate } from 'react-router';

const BankDetails = ({ step, handleStep, previous, confirmationDisplay, handleConfirmation }) => {

  const [isActive, setActive] = useState("false");
  const [list, setList] = useState([])
  const [loading, setLoading] = useState(false)
  const [display_confirm, setDisplayConfirm] = useState({ toggle: false, data: null })
  const navigate = useNavigate();
  const storage = JSON.parse(sessionStorage.getItem("transfer_data"))

  const handleToggle = () => {
    setActive(!isActive);
  };

  const handlePrevious = () => {
    sessionStorage.removeItem("send-step")
    sessionStorage.setItem("send-step", Number(step) - 1)
    handleStep(Number(step) - 1);
  }

  const handleClear = () => {
    sessionStorage.removeItem("transfer_data")
    sessionStorage.removeItem("send-step")
    navigate("/user-send-money", { replace: true });
    setTimeout(() => window.location.reload(), 10);
  }

  const handleCancel = () => {
    setActive(!isActive)
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth"
    })
  }

  const nextStep = () => {
    const value = display_confirm?.data?.recipient
    let storage = JSON.parse(sessionStorage.getItem('transfer_data'))
    let payload = {
      transaction_id: sessionStorage.getItem("transaction_id"),
      amount: {
        send_amount: storage?.amount?.send_amt,
        receive_amount: storage?.amount?.exchange_amt,
        send_currency: storage?.amount?.from_type,
        receive_currency: storage?.amount?.to_type,
        receive_method: "Bank transfer",
        reason: storage?.reason || previous?.reason || "none",
        payout_partner: previous && previous.recipient == value?.id ? previous?.payout_partner : value?.bank_name,
        exchange_rate: storage?.amount?.exchange_rate
      },
      recipient_id: value.id
    }
    createTransaction(payload).then(res => {
      if (res.code === "200") {
        sessionStorage.setItem("transaction_id", res?.data.transaction_id)
        sessionStorage.setItem("rid", value.id)
        if (sessionStorage.getItem("send-step")) {
          sessionStorage.removeItem("send-step")
        }
        sessionStorage.setItem("send-step", Number(step) + 1)
        handleStep(Number(step) + 1);
      }
    })
  }
  
const selectRecipient = async (value) => {
    let storage = JSON.parse(sessionStorage.getItem("transfer_data"))

    if (!value?.payout_currency) {
      setLoading(true)
      const transactionId = sessionStorage.getItem("transaction_id")
      const response = await updateRecipientCurrency({
        recipient_id: value?.id,
        transaction_id: transactionId,
      })
      setLoading(false)

      if (response?.code !== "200") {
        return
      }
    }

    const recipientData = {
      ...value,
      name: value.first_name + " " + value.last_name,
      bank_name: previous && previous.recipient == value?.id ? previous?.payout_partner : value?.bank_name
    };
    storage.recipient = recipientData;
    sessionStorage.setItem("transfer_data", JSON.stringify(storage));
    setDisplayConfirm({
      toggle: true,
      data: {
        amount: storage?.amount,
        recipient: recipientData
      }
    });

    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth"
    })
  }

  const finalAction = (values, data) => {
    let storage = JSON.parse(sessionStorage.getItem("transfer_data"));
    const recipientData = {
      ...data,
      name: data.first_name + " " + data.last_name
    };
    storage.recipient = recipientData;
    sessionStorage.setItem("transfer_data", JSON.stringify(storage));

    selectRecipient({ ...data });
  }


  useEffect(() => {
   const fetchList = async () => {
  setLoading(true)
  const payoutCurrency = storage?.amount?.to_type || "";
const response = await recipientList({ payout_currency: payoutCurrency });
  if (response && response.code === "200") {
    setList(response.data)
  }
  setLoading(false)
}
    fetchList();
  }, [isActive])

  useEffect(() => {
    // console.log(previous, confirmationDisplay)
    if (previous && previous.recipient && confirmationDisplay) {
      const storage = JSON.parse(sessionStorage.getItem("transfer_data"))
      setDisplayConfirm({ toggle: true, data: { amount: storage.amount, recipient: { ...storage.recipient, bank_name: previous.payout_partner } } })
      handleConfirmation()
    }
  }, [previous])
  
  return (
    <section>
      {
        display_confirm.toggle ? (
          <ReviewYourTransfer data={display_confirm} isConfirmation={false} handleCancel={() => { setActive(true); setDisplayConfirm({ toggle: false, data: null }) }} handleContinue={() => nextStep()} />
        ) : (
          <>
            <div className={isActive ? "col-md-12 add-recipent-section" : "col-md-12 remove-add-recipent-section"}>

              {loading ? <>
                <div className="loader-overly">
                  <div className="loader" >
                  </div>
                </div></> :
                <>
                  <div className="form-head d-flex mb-4">
                    <h2 className="text-black font-w600 mb-0 align-self-center"><b>Select a recipient to send money</b>
                    </h2>
                    <button type="button" className="form-button ms-auto m-0" onClick={() => handleToggle()} style={{ float: "right" }}><BsFillPersonPlusFill /> Add Recipient
                    </button>
                  </div>
                  <div className="card">
                    <div className="card-body">
                      {list?.length != 0 ? (
                        <div>
                          
                     {list?.map((item, index) => {
  const recipientName =
    item?.account_type === "business"
      ? item?.business_name
      : `${(item?.first_name || "").trim()} ${(item?.last_name || "").trim()}`;

  const maskedAccount = item?.account_number
    ? "********" + String(item.account_number).slice(-4)
    : "N/A";

  return (
    <ul key={item.id} style={{ listStyle: "none", padding: 0 }}>
      <li
        onClick={() => selectRecipient(item)}
        style={{
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "12px 16px",
          marginBottom: "8px",
          border: "1px solid #e5e7eb",
          borderRadius: "8px",
          backgroundColor: "#fff",
          transition: "background 0.15s",
        }}
        onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#f9fafb")}
        onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#fff")}
      >
<div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
  {/* Avatar with initials */}
  <div style={{
    width: 44,
    height: 44,
    borderRadius: "50%",
    background: "#7c3aed",
    color: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: 700,
    fontSize: 15,
    flexShrink: 0,
    letterSpacing: 1,
  }}>
    {recipientName.split(" ").map(w => w[0]).join("").slice(0, 2).toUpperCase()}
  </div>

  {/* Name + details */}
  <div>
    <div style={{ fontWeight: 600, fontSize: "14px", color: "#111827" }}>
      {recipientName}
    </div>
    {/* Line 1: bank · currency */}
    <div style={{ fontSize: "13px", color: "#6b7280", marginTop: "2px" }}>
      {item?.bank_name || ""}
      {item?.payout_currency && (
        <span style={{ color: "#9ca3af" }}> · {item.payout_currency}</span>
      )}
    </div>
    {/* Line 2: masked account */}
    <div style={{ fontSize: "13px", fontFamily: "monospace",fontStyle:"bold", letterSpacing: "0.05em" }}>
      •••• {String(item?.account_number || "").slice(-4)}
    </div>
  </div>
</div>

        {/* Right: Arrow */}
        <BsChevronDoubleRight style={{ color: "#9ca3af", flexShrink: 0 }} />
      </li>
    </ul>
  );
})}
                        </div>
                      ) : (
                        <>
                          <h4 className='text-center py-5'>No Recipients Found</h4>
                        </>
                      )
                      }
                      <div className="add- row">
                        <div className='col-md-4'>
                          <button type="button" className="start-form-button full-col" onClick={() => { handleClear() }} style={{ "float": "left" }}>Cancel</button>
                        </div>
                        <div className='col-md-8'>
                          <button type="button" className="form-button col-md-12 full-col" onClick={() => { handlePrevious() }} style={{ "float": "right" }}>Previous</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              }
            </div>
            <div className={isActive ? "removerecepient" : "showrecepient"} >
              <RecipientForm section={"transfer"} nextAction={finalAction} backHandler={handleCancel} currency={storage?.amount?.to_type} />
            </div>
          </>
        )

      }
    </section>
  )
}

export default BankDetails